var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding-top":"0px","padding-bottom":"0px"}},[_c('v-layout',[_c('v-flex',[_c('div',{attrs:{"id":"player"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }